import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      50: "#E2E8F0",
      100: "#CBD5E1",
      200: "#94A3B8",
      300: "#64748B",
      400: "#475569",
      500: "#334155",
      600: "#1E293B",
      700: "#1E3A8A",
      800: "#0F172A",
      900: "#0A0F1C",
    },
    accent: {
      blue: "#6952d7ff",
      green: "#10B981",
      gold: "#FACC15",
      silver: "#E2E8F0",
    },
  },
  fonts: {
    heading: `'Merriweather', serif`,
    body: `'Inter', sans-serif`,
  },
  styles: {
    global: {
      body: {
        bg: "brand.50",
        color: "brand.800",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "600",
        borderRadius: "xl",
      },
      variants: {
        solid: {
          bg: "accent.green",
          color: "brand.100",
          _hover: { bg: "accent.gold", color: "brand.800" },
        },
        outline: {
          borderColor: "accent.gold",
          color: "brand.700",
          _hover: { bg: "accent.gold", color: "brand.800" },
        },
      },
    },
  },
});

export default theme;
